"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteFormatter = void 0;
const KetteFormValidator_1 = require("./KetteFormValidator");
class KetteFormatter {
    static innenhoehe(options) {
        return KetteFormValidator_1.KetteFormValidator.innenhoehe(options);
    }
    static aussenhoehe(options) {
        return KetteFormValidator_1.KetteFormValidator.aussenhoehe(options);
    }
    static aussenbreite(options) {
        return KetteFormValidator_1.KetteFormValidator.aussenbreite(options);
    }
    static innenbreite(options) {
        return KetteFormValidator_1.KetteFormValidator.innenbreite(options);
    }
    static teilung(options) {
        return KetteFormValidator_1.KetteFormValidator.teilung(options);
    }
    static biegeradius(options) {
        return KetteFormValidator_1.KetteFormValidator.biegeradius(options);
    }
    static verfahrweg(options) {
        return KetteFormValidator_1.KetteFormValidator.verfahrweg(options);
    }
    static laenge(options) {
        return KetteFormValidator_1.KetteFormValidator.laenge(options);
    }
    static effektivelaenge(options) {
        return KetteFormValidator_1.KetteFormValidator.effektivelaenge(options);
    }
    static effektivelaengewithAE(options) {
        return KetteFormValidator_1.KetteFormValidator.effektivelaengewithAE(options);
    }
    static versatz(options) {
        return KetteFormValidator_1.KetteFormValidator.versatz(options);
    }
    static gewicht(options) {
        return KetteFormValidator_1.KetteFormValidator.gewicht(options);
    }
    static gliederAnzahl(options) {
        return KetteFormValidator_1.KetteFormValidator.gliederAnzahl(options);
    }
}
exports.KetteFormatter = KetteFormatter;
//# sourceMappingURL=KetteFormatter.js.map